var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.75C0.801893 15.7474 0.612629 15.6676 0.472534 15.5275C0.332439 15.3874 0.25259 15.1981 0.25 15V1C0.25 0.801088 0.329018 0.610322 0.46967 0.46967C0.610323 0.329018 0.801088 0.25 1 0.25C1.19891 0.25 1.38968 0.329018 1.53033 0.46967C1.67098 0.610322 1.75 0.801088 1.75 1V15C1.74741 15.1981 1.66756 15.3874 1.52747 15.5275C1.38737 15.6676 1.19811 15.7474 1 15.75ZM7 15.75C6.80189 15.7474 6.61263 15.6676 6.47253 15.5275C6.33244 15.3874 6.25259 15.1981 6.25 15V1C6.25 0.801088 6.32902 0.610322 6.46967 0.46967C6.61032 0.329018 6.80109 0.25 7 0.25C7.19891 0.25 7.38968 0.329018 7.53033 0.46967C7.67098 0.610322 7.75 0.801088 7.75 1V15C7.74741 15.1981 7.66756 15.3874 7.52747 15.5275C7.38737 15.6676 7.19811 15.7474 7 15.75Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.c5c02a7b45f710531462bfdc5cbe07ea.svg";
export { ForwardRef as ReactComponent };